import React, { useState, useEffect } from "react";
import "./Navbar.css";
import LogoName from "../../assets/img/logoname.png";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Profile from "../../assets/img/profile.png";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

export default function Navbar() {
  const classes = useStyles();
  const history = useHistory();

  const [menuExpand, setMenuExpand] = useState(false);
  return (
    <div>
      <div className="navbar-wrapper">
        <div className="logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="45"
            height="45"
            viewBox="0 0 142.047 122.188"
          >
            <path
              id="Path_3480"
              data-name="Path 3480"
              d="M57.515-123.3l-4.309-65.245s32.517,4.073,31.054,36.27c0,0,11.5-61.848,38.888-60.016s41.974,82.074-12.828,120.632c-2.322,1.634-8.449,3.391-6.857-3.124.369-1.51,2.235-2.9,4.246-4.892,43.852-43.445,28.912-92.27,13.848-100.393S88-150.84,89.689-140.6s2.137-7.145,9.516-5.708c17.541,3.416,9.261,39.432-11.324,33.622-15.665-4.422-7.245-30.284-12.593-43.681C68.637-173.024,61.579-172.9,61.579-172.9s-1.827,44.679.573,52.844a9.234,9.234,0,0,1,.5,2.626,6.929,6.929,0,0,1,0,1.83c-.787,6.047-8.9,11.971-18.1,13.221s-16.031-2.644-15.244-8.691,8.9-11.972,18.1-13.222A19.62,19.62,0,0,1,57.515-123.3Zm104.563-45.711a8.419,8.419,0,0,1,9.181,7.573,8.418,8.418,0,0,1-7.572,9.181,8.421,8.421,0,0,1-9.182-7.572A8.421,8.421,0,0,1,162.078-169.007Zm-2.6-27.092a8.421,8.421,0,0,1,9.182,7.572,8.42,8.42,0,0,1-7.573,9.182,8.419,8.419,0,0,1-9.181-7.572A8.42,8.42,0,0,1,159.475-196.1Z"
              transform="translate(-29.252 212.327)"
              fill="#fff"
              fillRule="evenodd"
            />
          </svg>

          <img className="logoname" src={LogoName} alt="no" />
        </div>

        <div className="nav-links">
          <div onClick={() => history.push("/")}>Home</div>
          <div onClick={() => history.push("/create")}>Create</div>
          <div onClick={() => history.push("/discover")}>Discover</div>
          <div onClick={() => history.push("/playlist")}>Playlist</div>
        </div>

        <div>
          <input type="text" className="search-input" placeholder="Search" />
          <div className="search-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16.667"
              height="16.667"
              viewBox="0 0 16.667 16.667"
            >
              <path
                id="Shape"
                d="M15.833,16.667a.828.828,0,0,1-.589-.244l-4.489-4.49a6.606,6.606,0,0,1-4.088,1.4,6.667,6.667,0,1,1,6.667-6.667,6.6,6.6,0,0,1-1.4,4.088l4.49,4.489a.834.834,0,0,1-.59,1.423Zm-9.166-15a5,5,0,1,0,5,5A5.006,5.006,0,0,0,6.667,1.666Z"
                fill="#eeeeef"
              />
            </svg>
          </div>
        </div>

        <div className="notifications">
          <div className="green-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <rect
                id="Status_New_Background_Mask_"
                data-name="Status/New (Background/Mask)"
                width="12"
                height="12"
                rx="6"
                fill="#b1d868"
              />
            </svg>
          </div>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="24"
            viewBox="0 0 18 19"
          >
            <path
              id="Vector"
              d="M9,19a2.258,2.258,0,0,1-1.591-.647l-.073-.174a1,1,0,0,1,.922-1.389H9.743a1,1,0,0,1,.922,1.389l-.073.174A2.258,2.258,0,0,1,9,19Zm8.116-3.093H.884a.883.883,0,1,1,0-1.767H.9V7.981A8.05,8.05,0,0,1,9,0a8.05,8.05,0,0,1,8.1,7.981V14.14h.016a.883.883,0,1,1,0,1.767ZM9,1.768A6.264,6.264,0,0,0,2.7,7.981V14.14H15.3V7.981A6.264,6.264,0,0,0,9,1.768Z"
              fill="#ebe3e1"
            />
          </svg>
        </div>

        <div className="connect-wallet">
          <div>Connect to Wallet</div>
        </div>

        <div className="username">
          <div className="username-text">Username</div>
          <Avatar
            alt="Remy Sharp"
            src={Profile}
            className={classes.large}
            style={{ cursor: "pointer" }}
            onClick={() => history.push("/profile")}
          />
        </div>

        <div className="menu-icon" onClick={() => setMenuExpand(!menuExpand)}>
          {menuExpand ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="white"
              class="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="white"
              class="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          )}
        </div>
      </div>
      {menuExpand ? (
        <div className="menu-expand">
          <div>
            <div className="mobile-search">
              <input
                type="text"
                className="search-input-mobile"
                placeholder="Search"
              />
              <div className="search-icon-mobile">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16.667"
                  height="16.667"
                  viewBox="0 0 16.667 16.667"
                >
                  <path
                    id="Shape"
                    d="M15.833,16.667a.828.828,0,0,1-.589-.244l-4.489-4.49a6.606,6.606,0,0,1-4.088,1.4,6.667,6.667,0,1,1,6.667-6.667,6.6,6.6,0,0,1-1.4,4.088l4.49,4.489a.834.834,0,0,1-.59,1.423Zm-9.166-15a5,5,0,1,0,5,5A5.006,5.006,0,0,0,6.667,1.666Z"
                    fill="#eeeeef"
                  />
                </svg>
              </div>
            </div>
            <div className="mobile-head-wrapper">
              <div className="connect-wallet-mobile">
                <div>Connect to Wallet</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="mobile-notifications"
                  style={{ marginRight: "20px", paddingTop: "12px" }}
                >
                  <div className="green-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                    >
                      <rect
                        id="Status_New_Background_Mask_"
                        data-name="Status/New (Background/Mask)"
                        width="12"
                        height="12"
                        rx="6"
                        fill="#b1d868"
                      />
                    </svg>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="24"
                    viewBox="0 0 18 19"
                  >
                    <path
                      id="Vector"
                      d="M9,19a2.258,2.258,0,0,1-1.591-.647l-.073-.174a1,1,0,0,1,.922-1.389H9.743a1,1,0,0,1,.922,1.389l-.073.174A2.258,2.258,0,0,1,9,19Zm8.116-3.093H.884a.883.883,0,1,1,0-1.767H.9V7.981A8.05,8.05,0,0,1,9,0a8.05,8.05,0,0,1,8.1,7.981V14.14h.016a.883.883,0,1,1,0,1.767ZM9,1.768A6.264,6.264,0,0,0,2.7,7.981V14.14H15.3V7.981A6.264,6.264,0,0,0,9,1.768Z"
                      fill="#ebe3e1"
                    />
                  </svg>
                </div>
                <div className="mobile-username">
                  {/* <div className="username-text">Username</div> */}
                  <Avatar
                    alt="Remy Sharp"
                    src={Profile}
                    className={classes.medium}
                    style={{ cursor: "pointer" }}
                    onClick={() => history.push("/profile")}
                  />
                </div>
              </div>
            </div>

            <div className="mobile-nav-links">
              <div
                onClick={() => {
                  history.push("/");
                  setMenuExpand(!menuExpand);
                }}
              >
                Home
              </div>
              <div
                onClick={() => {
                  history.push("/discover");
                  setMenuExpand(!menuExpand);
                }}
              >
                Discover
              </div>
              <div
                onClick={() => {
                  history.push("/playlist");
                  setMenuExpand(!menuExpand);
                }}
              >
                Playlist
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
